export default __webpack_public_path__ + "static/media/favicon.9a68b2bb.ico";